

















import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import {FreightServiceAdd} from "@/interfaces/entity";

@Component({
    name: "FreightServiceAddTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly serviceId!: string;

    get freightServiceAdd(): FreightServiceAdd {
        return FreightServiceAddStore.data[this.serviceId];
    }

    async onConfirm() {
        try {
            await FreightServiceAddStore.deleteFreightServiceAdd(this.serviceId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa dịch vụ thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa dịch vụ thất bại"
            });
        }
    }
}
